export default __webpack_public_path__ + "static/media/hyung_jin_gong.ccd49524.png";